// extracted by extract-css-chunks-webpack-plugin
module.exports = {"InputSearch_Container":"InputSearch_Container_2QWAh_v16-5-1","InputSearch_Icon":"InputSearch_Icon_s_Iil_v16-5-1","InputSearch":"InputSearch_LSH0X_v16-5-1"};